import { render, staticRenderFns } from "./myChoice.vue?vue&type=template&id=36667676"
import script from "./myChoice.vue?vue&type=script&lang=js"
export * from "./myChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports